
import { u } from "framer-motion/client";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";

const FactCheck = () => {
  const {t, i18n} = useTranslation();
  const [statement, setStatement] = useState("");
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(false);
  const handleCheck = async () => {
    const token = localStorage.getItem("token");
    setLoading(true);
    
    //  endpoint selon la langue active
    const endpoint = i18n.language === "en"
        ? "https://mydatacheck.site/check/fact-en"
        : "https://mydatacheck.site/check/fact"; // fr par défaut
    const res = await fetch(endpoint, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ statement }),
    });

    const data = await res.json();
    setResult(data);
    setLoading(false);
  };
 
  return (
    <div className="p-8 max-w-2xl mx-auto   text-gray-800 dark:text-white min-h-[100vh]">
      <h1 className="text-2xl font-bold mb-4 text-[#42AB3F]">{t("factcheck1")}</h1>
      <textarea
        value={statement}
        onChange={(e) => setStatement(e.target.value)}
        className="w-full p-2 border rounded mb-4 dark:text-gray-800"
        placeholder={t("factcheckPlaceHolder")}
        required
      />
      <button
        onClick={handleCheck}
        className="bg-[#DA6E2f] text-white px-4 py-2 rounded  text-gray-800 dark:text-white min-h-full"
      >
        {loading ? 
          <div className="fixed inset-0 z-50 flex items-center justify-center bg-white/40 backdrop-blur-sm">
            <div className="flex flex-col items-center space-y-2">
              <div className="animate-spin rounded-full h-12 w-12 border-t-4 border-b-4 border-[#DA6E2f]"></div>
              <p className="text-lg font-semibold text-[#DA6E2f]">
                {t("factcheck2")}
              </p>
            </div>
          </div>
         : <span>{t("factcheck3")}</span>}
      </button>
      {result && (
        <div className="mt-4 p-4 bg-white dark:bg-white rounded shadow  overflow-y-scroll">
          <h2 className="font-bold text-lg mb-2 dark:text-black">{result.statement}</h2>
          {/* <p className="text-sm  dark:text-black text-black mb-2">{result.verdict}</p> */}
          {result.sources?.length > 0 ? (
            result.sources.map((source, i) => (
              
              <div key={i} className="mb-2 border-2 shadow-md p-4 rounded-lg bg-gray-50 dark:bg-gray-200">
                <p className="font-semibold dark:text-black poppins">{source.text}</p>
                <p className="text-sm text-[#DA6E2f]">{source.publisher}</p>
                <p className="text-sm text-blue-600 mb-1">
                  <a href={source.url} target="_blank" rel="noopener noreferrer" className="hover:underline">
                    {source.url ? t("factcheck5") : t("factcheck6")}
                  </a>
                </p>
                <span className="bg-gray-100 dark:bg-gray-700 px-2 py-1 rounded text-xs">
                  {source.rating}
                </span> 
              </div>
            ))
          ) : (
            <p className="text-sm italic text-red-500">{t("factcheck4")}</p>
          )}
        </div>
      )}
    </div>
  );
};

export default FactCheck;
